import cookies from "js-cookie";
import { Cookies } from "./constants";
import { jwtDecode } from "./utils";

export enum CookieState {
	StartSignedIn = 'Start signed in',
	StartSignedOut = 'Start signed out',
	SignedIn = 'Signed in',
	SignedOut = 'Signed out',
	UserChanged = 'User changed',
	NoChange = 'No change',
	Disabled = 'Disabled',
}

export class SessionWatcher {
	lastSignedInUser: number | undefined;
	testLogger?: (message: string) => void;
	enabled: boolean = true;

	constructor(testLogger?: (message: string) => void) {
		this.testLogger = testLogger;
		window.addEventListener('storage', this.handleStorageMessage);
		const refreshToken = cookies.get(Cookies.refreshToken);

		if (refreshToken) {
			this.testLogger?.(CookieState.StartSignedIn);
			const decoded = jwtDecode(refreshToken) as { id: number };
			this.lastSignedInUser = decoded.id;
		} else {
			this.testLogger?.(CookieState.StartSignedOut);
		}

		setInterval(this.trackRefreshToken, 2000);
	}

	private trackRefreshToken = () => {
		if (!this.enabled) {
			this.testLogger?.(CookieState.Disabled);
			return;
		}

		// get the refresh token from the cookie
		const refreshToken = cookies.get(Cookies.refreshToken);

		// user was signed in and now is signed out
		if (this.lastSignedInUser && !refreshToken) {
			this.testLogger?.(CookieState.SignedOut);
			return window.location.reload();
		}

		// there is a refresh token
		if (refreshToken) {

			// check the id of the refresh token from the cookie
			const decoded = jwtDecode(refreshToken) as { id: number };
			const id = decoded.id;

			// user has just signed in 
			if (!this.lastSignedInUser) {
				this.testLogger?.(CookieState.SignedIn);
				this.lastSignedInUser = id;
			} else if (this.lastSignedInUser && id !== this.lastSignedInUser) {
				// user has signed in as a different user
				this.testLogger?.(CookieState.UserChanged);
				return window.location.reload();
			} else {
				this.testLogger?.(CookieState.NoChange);
			}
		} else {
			this.testLogger?.(CookieState.NoChange);
		}
	};

	public signedIn = () => {
		localStorage.setItem('bl#signed_in_at', new Date().toISOString());
	}

	public signedOut = () => {
		localStorage.setItem('bl#signed_out_at', new Date().toISOString());
	}

	public handleStorageMessage = ({ key, oldValue, newValue }: StorageEvent) => {
		if (key === 'bl#signed_in_at' || key === 'bl#signed_out_at') {
			// value of signed_in_at as changed (user has re-authorized in another window).
			// or value of signed_out_at has changed (user has signed out in another window).
			if (oldValue !== newValue) {
				window.location.href = window.location.origin;
			}
		}
	}
}
